export type Character = {
  id: string;
  name: string;
  role: "主角" | "配角" | "反派";
  avatar: string;
  tagline: string;
  description: string;
  personality: string;
  appearanceOrder: number;
  appearances: string[];
};

export const characters: Character[] = [
  {
    id: "su-wan",
    name: "苏晚",
    role: "主角",
    avatar:
      "https://readdy.ai/api/search-image?query=Gentle%20young%20woman%20with%20long%20dark%20hair%20and%20soft%20eyes%20holding%20a%20notebook%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20warm%20key%20light%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-01&orientation=portrait",
    tagline: "把日子过成诗的甜品店女孩",
    description:
      "本作女主角。来自小城的普通女孩，靠兼职与奖学金在临江读书，梦想成为一名自由撰稿人。她在旧书店偶遇顾时衍，从此人生轨迹被悄然改变。苏晚外表温和，内心却极有主见，即使面对误解与背叛，也始终选择用自己的方式站立起来。",
    personality: "外柔内刚、细腻敏感、认死理；嘴上说着不在意，转身却把所有情绪写进本子里。",
    appearanceOrder: 1,
    appearances: ["ep-01", "ep-02", "ep-03", "ep-04", "ep-05", "ep-06", "ep-07", "ep-08", "ep-09", "ep-11", "ep-12"],
  },
  {
    id: "gu-shiyan",
    name: "顾时衍",
    role: "主角",
    avatar:
      "https://readdy.ai/api/search-image?query=Cool%20young%20man%20with%20short%20dark%20hair%20in%20a%20tidy%20coat%20holding%20a%20black%20umbrella%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20soft%20rim%20light%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-02&orientation=portrait",
    tagline: "把温柔藏进沉默里的人",
    description:
      "本作男主角。临江顾家的继承人，年纪轻轻便接手家族企业的一部分事务。习惯把所有情绪压进心底，用克制代替表达。他在旧书店与苏晚相遇后，第一次开始学着把心里的话说出口，也第一次为一个人打破自己所有的规则。",
    personality: "沉默寡言、外冷内热、责任感极强；不擅长解释，却会用行动把在意做到极致。",
    appearanceOrder: 2,
    appearances: ["ep-01", "ep-02", "ep-03", "ep-04", "ep-05", "ep-06", "ep-08", "ep-10", "ep-11", "ep-12"],
  },
  {
    id: "lin-xiaoman",
    name: "林小满",
    role: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Cheerful%20young%20woman%20with%20a%20short%20bob%20hairstyle%20and%20a%20bright%20smile%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20bright%20playful%20lighting%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-03&orientation=portrait",
    tagline: "苏晚的室友，也是全剧最快乐的人",
    description:
      "苏晚的大学室友兼最好的朋友，甜品店的合伙人。性格开朗直率，是唯一敢当面戳破苏晚逞强的人。她曾在中学时代与顾时衍有过一面之缘，成为连接两人过去与现在的一条暗线。",
    personality: "大大咧咧、热心肠、行动力满分；看似没心没肺，其实比谁都看得清楚。",
    appearanceOrder: 3,
    appearances: ["ep-02", "ep-04", "ep-06", "ep-12"],
  },
  {
    id: "chen-mo",
    name: "陈默",
    role: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Composed%20young%20man%20with%20neat%20hair%20and%20a%20simple%20shirt%2C%20calm%20expression%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20steady%20neutral%20light%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-04&orientation=portrait",
    tagline: "顾时衍身边最可靠的人",
    description:
      "顾时衍的私人助理，跟在他身边多年，是少数知道顾家旧事的人。做事滴水不漏，永远在关键节点替顾时衍兜底，也是他主动找到苏晚，试图推动两个闷葫芦走出僵局。",
    personality: "沉稳可靠、克制专业、重情义；话不多，但每句都算数。",
    appearanceOrder: 4,
    appearances: ["ep-04", "ep-07", "ep-10"],
  },
  {
    id: "zhou-yiran",
    name: "周亦然",
    role: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Relaxed%20young%20man%20with%20messy%20hair%20and%20a%20casual%20jacket%2C%20friendly%20half%20smile%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20soft%20daylight%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-05&orientation=portrait",
    tagline: "游走在两边之间的旧友",
    description:
      "顾时衍的大学同学，如今是沈氏集团的项目顾问。立场一度模糊，看似站在沈奕一边，实则一直在暗中收集证据。在真相浮现的关键时刻，他选择站出来，完成自我救赎。",
    personality: "散漫随性、左右逢源、心里有杆秤；关键时刻比谁都拎得清。",
    appearanceOrder: 5,
    appearances: ["ep-05", "ep-08", "ep-10"],
  },
  {
    id: "wen-rou",
    name: "温柔",
    role: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Elegant%20young%20woman%20with%20soft%20wavy%20hair%20and%20a%20gentle%20expression%20holding%20a%20teacup%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20warm%20ambient%20light%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-06&orientation=portrait",
    tagline: "甜品店老板娘，看得最透的局外人",
    description:
      "苏晚打工的甜品店老板娘，年长几岁，是店里最温暖的定海神针。她从不多问客人的故事，却总在关键时刻点醒苏晚一句。她做的招牌舒芙蕾，是整部剧里'甜'的具象化身。",
    personality: "通透温柔、云淡风轻、洞察人心；说话不紧不慢，却句句戳中要害。",
    appearanceOrder: 6,
    appearances: ["ep-02", "ep-03", "ep-06", "ep-12"],
  },
  {
    id: "shen-yi",
    name: "沈奕",
    role: "反派",
    avatar:
      "https://readdy.ai/api/search-image?query=Sharp%20young%20man%20in%20a%20dark%20tailored%20suit%20with%20a%20cold%20confident%20gaze%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20dramatic%20side%20light%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-07&orientation=portrait",
    tagline: "藏在微笑背后的算计者",
    description:
      "沈氏集团继承人，顾时衍商场上的对手。表面风度翩翩，实则步步为营。他策划了资料泄露事件嫁祸苏晚，动机源于两家更早的一场竞争。即使败露，他依然保持着体面的微笑，是整部剧里最危险的对手。",
    personality: "野心勃勃、精于算计、极度自负；从未把感情算进棋盘，因此看不透别人可以为爱让步。",
    appearanceOrder: 7,
    appearances: ["ep-05", "ep-07", "ep-08", "ep-10"],
  },
  {
    id: "han-xue",
    name: "韩雪",
    role: "反派",
    avatar:
      "https://readdy.ai/api/search-image?query=Ambitious%20young%20woman%20with%20sleek%20hair%20and%20a%20poised%20expression%20in%20a%20smart%20blazer%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20cool%20crisp%20light%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-08&orientation=portrait",
    tagline: "在利益与良心之间摇摆的人",
    description:
      "沈奕身边的执行者，负责处理那些不便见光的琐事。她一度是泄密事件的直接执行者，但在最后关头选择交出备份文件，完成了自己的转身。她不是纯粹的恶人，只是被现实推着走的人。",
    personality: "精明干练、审时度势、心有挣扎；关键时刻的那一步，让她不再只是工具。",
    appearanceOrder: 8,
    appearances: ["ep-07", "ep-08", "ep-10"],
  },
  {
    id: "lao-zhou",
    name: "老周",
    role: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Kind%20elderly%20bookstore%20owner%20with%20round%20glasses%20and%20grey%20hair%20holding%20an%20old%20book%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20clean%20simple%20background%2C%20warm%20lamp%20light%2C%20elegant%20character%20portrait&width=600&height=800&seq=sp-ch-09&orientation=portrait",
    tagline: "旧书店的守店人，故事开始的地方",
    description:
      "藏在巷子深处的旧书店老板，也是所有故事开始与重逢的见证者。他从不卖畅销书，只在每本书里留下手写的批注。苏晚与顾时衍的每一次相遇与告别，都发生在这间小小的书店里。",
    personality: "慈祥通透、云淡风轻、爱书如命；总说'书里夹着的，都是没说出口的话'。",
    appearanceOrder: 9,
    appearances: ["ep-01", "ep-09", "ep-11", "ep-12"],
  },
];